import type { PopupImportRowValues } from "./validationSchema";

let fallbackIdCounter = 0;

/** Client-only stable id for React keys; never sent to import API. */
export function createPopupImportClientRowId(): string {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  fallbackIdCounter += 1;
  return `import-row-${Date.now()}-${fallbackIdCounter}`;
}

export function ensurePopupImportClientRowIds(
  rows: PopupImportRowValues[]
): PopupImportRowValues[] {
  return rows.map((row) =>
    row._clientRowId?.trim()
      ? row
      : { ...row, _clientRowId: createPopupImportClientRowId() }
  );
}
